module.exports = __webpack_public_path__ + "static/media/Apple iPad Pro 11\" Space Gray - Landscape.f3d73a27.png";